import React from "react"

import { Skeleton } from "../Skeleton"

type LineGraphSilhouetteProps = {
  height?: number
}

const LineGraphSilhouette: React.FC<LineGraphSilhouetteProps> = ({ height = 166 }) => {
  const headerHeight = 20
  const graphHeight = height - headerHeight - 42 // Adjusting for padding and other fixed heights
  const svgHeight = Math.max(graphHeight, 50) // Ensure svg height is not too small

  return (
    <Skeleton className={`w-full h-[${height}px] p-5`}>
      <div className="flex justify-between">
        <div className="h-3 rounded-full bg-gray-300 max-w-[100px] grow"></div>
        <div className="h-3 rounded-full bg-gray-300 max-w-[150px] grow"></div>
      </div>
      <div className="flex flex-row justify-between w-full">
        <div className="flex flex-col justify-between my-3 gap-2 grow mr-2 max-w-5">
          {[...Array(5)].map((_, index) => (
            <div key={index} className="h-2 rounded-full bg-gray-300 max-w-[20px]"></div>
          ))}
        </div>

        <div className="grow">
          <div
            className="flex justify-between items-end w-full align-bottom"
            style={{ height: svgHeight }}
          >
            {/* SVG fills container */}
            <svg viewBox="0 0 420 100" xmlns="http://www.w3.org/2000/svg" className="grow">
              <path
                d="M0,80 L40,50 L80,30 L120,20 L160,35 L200,40"
                fill="none"
                stroke="#D1D5DB"
                strokeWidth="4"
              />
              <path
                d="M210,40 L230,50 L250,35 L270,40 L290,36 L310,40 L330,45 L350,30 L370,40 L420,20"
                fill="none"
                stroke="#D1D5DB"
                strokeWidth="4"
              />
            </svg>
          </div>
        </div>
      </div>

      <div className="flex flex-row justify-around">
        {[...Array(5)].map((_, index) => (
          <React.Fragment key={`block-row-${index}`}>
            <div key={index} className="grow h-2 rounded-full bg-gray-300 max-w-[20px] mb-2"></div>
          </React.Fragment>
        ))}
      </div>
    </Skeleton>
  )
}

export default LineGraphSilhouette
